import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import apiRequest from '../../lib/http'
import { normalizeError } from '../../utils/errorHelpers'

// Defined in ./selectors so a flag-reading component never imports lib/http: axios is ESM-only and
// CRA's jest leaves node_modules untransformed, so that edge breaks any suite without a http mock.
export { selectFeatureFlags, selectFeatureFlag, selectFeatureFlagsSettled } from './selectors'

export const fetchFeatureFlags = createAsyncThunk(
  'featureFlags/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get('/feature-flags')
      return response.data.data
    } catch (error) {
      return rejectWithValue(normalizeError(error))
    }
  }
)

const initialState = {
  flags: [],
  loading: false,
  error: null,
  settled: false,
}

const featureFlagsSlice = createSlice({
  name: 'featureFlags',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFeatureFlags.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchFeatureFlags.fulfilled, (state, action) => {
        state.loading = false
        state.settled = true
        state.flags = Array.isArray(action.payload?.flags) ? action.payload.flags : []
      })
      .addCase(fetchFeatureFlags.rejected, (state, action) => {
        state.loading = false
        state.settled = true
        state.error = action.payload
        state.flags = []
      })
  },
})

export default featureFlagsSlice.reducer
